if (!customElements.get('search-results-remaining')) {
  class SearchResultsRemaining extends HTMLElement {
    constructor() {
      super();

      this.resultsWrapper = this.querySelector('[data-results]');

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        const searchQuery = window.location.search.split('q=')[1].split('&')[0];

        fetch(`${window.location.pathname}?q=${searchQuery}&type=article,page&?section_id=search-main`)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const resultsWrapper = html.querySelector(
              '[data-results]',
            );

            if (resultsWrapper && resultsWrapper.innerHTML.trim().length) {
              this.resultsWrapper.innerHTML = resultsWrapper.innerHTML;
              this.classList.remove('is-hidden');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('search-results-remaining', SearchResultsRemaining);
}
